import mod from "-!./ALink.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./ALink.js?vue&type=script&lang=js&external"